<template>
  <div class="alert-settings">
    <div class="header">
      <h1 class="title">通知</h1>
    </div>
    <div class="section">
      <div class="container">
        <h2 class="title">通知有無設定</h2>
        <dl class="columns">
          <input id="box1" type="checkbox" v-model="water_level_warn.valid" />
          <label for="box1">警告水位通知</label>
        </dl>
        <dl class="columns">
          <input
            id="box2"
            type="checkbox"
            v-model="water_level_caution.valid"
          />
          <label for="box2">危険水位通知</label>
        </dl>
        <h2 class="title">通知時刻設定</h2>
        <input
          class="box_alltime"
          id="box_alltime"
          type="checkbox"
          v-model="alltime"
          @click="toggle_alltime"
        />
        <label for="box_alltime">毎時通知</label>
        <div class="repeat" for="box_alltime">
          <div v-for="h in hours" :key="h">
            <input
              :id="`box_${h}h`"
              type="checkbox"
              v-model="notification_times"
              :value="h"
            />
            <label :for="`box_${h}h`">{{ h }}時</label>
          </div>
        </div>
      </div>
    </div>
    <span class="btn-submit" @click="update">保存</span>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";

export default {
  mixins: [Loader],

  data() {
    return {
      water_level_warn: {
        notification_type: "00",
        valid: true,
      },
      water_level_caution: {
        notification_type: "01",
        valid: true,
      },
      alltime: true,
      notification_times: [],
    };
  },

  computed: {
    hours() {
      let hours = [];
      for (let i = 0; i < 24; i++) {
        hours.push(i);
      }
      return hours;
    },
  },

  async mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      await this.show();
    });
  },

  methods: {
    ...mapActions([
      "retrieveNotificationSettings",
      "updateNotificationSettings",
    ]),
    ...mapGetters(["getAccountID"]),

    async show() {
      try {
        const retWaterLevelWarn = await this.retrieveNotificationSettings({
          notification_type: this.water_level_warn.notification_type,
        });
        const retWaterLevelCaution = await this.retrieveNotificationSettings({
          notification_type: this.water_level_caution.notification_type,
        });
        if (!retWaterLevelWarn || !retWaterLevelCaution) {
          return;
        }

        var notificationTime = new Set();
        // 警告水位通知設定
        if (retWaterLevelWarn.notification_settings) {
          if (retWaterLevelWarn.notification_settings.valid) {
            this.water_level_warn.valid =
              retWaterLevelWarn.notification_settings.valid;
          }
          if (retWaterLevelWarn.notification_settings.notification_time) {
            for (const time of retWaterLevelWarn.notification_settings
              .notification_time) {
              notificationTime.add(time);
            }
          }
        }
        // 危険水位通知設定
        if (retWaterLevelCaution.notification_settings) {
          if (retWaterLevelCaution.notification_settings.valid) {
            this.water_level_caution.valid =
              retWaterLevelCaution.notification_settings.valid;
          }
          if (retWaterLevelCaution.notification_settings.notification_time) {
            for (const time of retWaterLevelCaution.notification_settings
              .notification_time) {
              notificationTime.add(time);
            }
          }
        }

        // 通知時間を反映
        this.notification_times = Array.from(notificationTime.values());
        if (this.notification_times.length === this.hours.length) {
          this.alltime = true;
        } else {
          this.alltime = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async update() {
      // 通知時間を昇順ソートしておく
      this.notification_times.sort((a, b) => {
        if (a === b) return 0;
        return a < b ? -1 : 1;
      });

      try {
        await this.updateNotificationSettings({
          notification_type: this.water_level_warn.notification_type,
          notification_settings: {
            valid: this.water_level_warn.valid,
            notification_time: this.notification_times,
          },
        });
        await this.updateNotificationSettings({
          notification_type: this.water_level_caution.notification_type,
          notification_settings: {
            valid: this.water_level_caution.valid,
            notification_time: this.notification_times,
          },
        });
        alert("保存しました。");
      } catch (error) {
        console.log(error);
        alert("保存に失敗しました。");
      }
    },
    toggle_alltime() {
      // 通知時間を一括変更
      for (let time = 0; time < this.notification_time.length; time++) {
        this.notification_time[time] = !this.alltime;
      }
    },
  },
};
</script>

<style lang="scss" src="">
.alert-settings {
  .header {
    margin: 2rem;
  }
  .section {
    overflow: auto;
    width: 80%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;

      dl.columns {
        width: 100%;
        display: grid;
        grid-template-columns: 170px 1fr;
        align-items: top;
        grid-gap: 0px 0px;
        margin: 0;
        padding: 0;
        font-size: 16px;
        color: #333;
      }

      .columns dt {
        display: block;
        text-align: left;
        width: 100%;
        margin: 0;
        padding: 16px;
      }

      .columns dd {
        display: block;
        width: 100%;
        border-left: solid 1px #ddd;
        margin: 0;
        padding: 16px;

        &.input-with-unit {
          display: flex;
          align-items: center;
          .unit {
            margin-left: 1rem;
            word-break: keep-all;
          }
        }
      }
      .columns dt:nth-of-type(odd) {
        background: #f3f3f3;
      }
      .columns dd:nth-of-type(odd) {
        background: #f3f3f3;
      }

      .repeat {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
      }
      input[type="checkbox"]:checked ~ .repeat {
        display: none;
      }

      /* フォーム */

      input[type="text"],
      input[type="date"] {
        width: 100%;
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 16px;
        font-size: 16px;
        outline: none;
      }

      input[type="text"]:focus,
      input[type="date"]:focus {
        background: var(--purple-tertiary);
      }

      select {
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 38px 0 16px;
        font-size: 16px;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center;
        background-size: 25px 25px;
      }

      select:focus {
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center var(--purple-tertiary);
        background-size: 25px 25px;
      }

      textarea {
        font-size: 16px;
        width: 100%;
        min-height: 200px;
        white-space: pre-wrap;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: solid 1px var(--purple);
        padding: 10px;
        border-radius: 10px 10px 0 10px;
      }

      textarea:focus {
        background: var(--purple-tertiary);
      }

      input[type="radio"] {
        display: none;
      }
      input[type="radio"] + label {
        padding: 0 20px 0 0;
      }
      input[type="radio"]:disabled + label {
        color: #aaa;
      }

      input[type="radio"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="radio"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center left;
        background-size: 24px 24px;
        display: inline-block;
      }
      input[type="radio"]:disabled + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
          center left;
        background-size: 24px 24px;
        display: inline-block;
      }

      input[type="checkbox"] {
        display: none;
      }
      input[type="checkbox"] + label {
        padding: 0 20px 0 0;
      }

      input[type="checkbox"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="checkbox"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
          left;
        background-size: 24px 24px;
        display: inline-block;
      }
    }
  }
  .btn-submit {
    display: block;
    background: var(--purple);
    font-size: 14px;
    text-align: center;
    width: 100px;
    height: 30px;
    border-radius: 15px;
    color: #fff;
    padding: 6px 20px;
    margin: 10px auto 10px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
    }
  }
  .p-modal {
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    visibility: hidden;
    opacity: 0;
    z-index: -1;
    &.is-open {
      visibility: visible;
      opacity: 1;
      z-index: 100;
    }
    .modal-main {
      display: inline-block;
      text-align: center;
      padding: 10px 20px;
      border-radius: 10px;
      background: #fff;
    }
  }
}
</style>
